import { toast } from "react-toastify";
import { clearIndexDB } from "../db";
import { handleLogoutForUnAuth } from "./handleLogoutForUnAuth";

export const Postrequestcall = async (apiPath, payload, token, formData) => {
  try {
    let auth = {};
    if (typeof token !== "undefined" && token !== null && token !== "") {
      auth = {
        Authorization: `Bearer ${token}`
      };
    }
    let headers = {
      ...auth,
      Accept: "application/json",
      "Content-Type": formData ? "multipart/form-data" : "application/json"
    };

    const getResponse = await window.axios
      .post(`${import.meta.env.REACT_APP_BASE_URL}/${apiPath}`, payload, {
        headers: headers
      })
      .then(function (result) {
        return result;
      })
      .catch((err) => err.response);

    if (getResponse?.status === 401) {
      await handleLogoutForUnAuth();
      return;
    }

    return getResponse;
  } catch (error) {
    if (error?.message?.includes("401")) {
      await handleLogoutForUnAuth();
      return;
    }
    throw error;
  }
};
